import type { OnPageTransitionEndAsync } from "vike/types";

export const onPageTransitionEnd: OnPageTransitionEndAsync = async () => {
  document.querySelector("body")?.classList.remove("page-is-transitioning");
  try {
    if (import.meta.env.PROD && (window as any).gtag && typeof (window as any).gtag === "function") {
      const path = window.location.pathname + window.location.search + window.location.hash;
      (window as any).gtag("event", "page_view", {
        page_path: path,
      });
    }
  } catch {}
};
